<template>
  <v-list-item
    :to="to"
    :link="link"
    :href="href"
    :target="target"
    :disabled="disabled"
    :input-value="value"
    @click="onClick"
  >
    <v-list-item-action v-if="icon !== null && badge === null">
      <v-tooltip
        right
        open-delay="270"
        :disabled="!tooltip"
      >
        <template #activator="{ on, attrs }">
          <v-icon
            :color="colorForIcon"
            v-bind="attrs"
            v-on="on"
          >
            {{ value && filledIcon ? filledIcon : icon }}
          </v-icon>
        </template>
        <span>{{ title }}</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-action v-if="icon !== null && badge !== null">
      <v-tooltip
        right
        open-delay="270"
        :disabled="!tooltip"
      >
        <template #activator="{ on, attrs }">
          <v-badge
            overlap
            :content="badge"
            color="red"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon :color="colorForIcon">
              {{ icon }}
            </v-icon>
          </v-badge>
        </template>
        <span>{{ title }}</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-if="labelBadge === null">
        {{ title }}
      </v-list-item-title>
      <v-list-item-title v-else>
        <v-badge
          class="pa-0 ma-0"
          color="success"
          :content="labelBadge"
          inline
        >
          {{ title }}
        </v-badge>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import Vue from 'vue';
import { Route } from 'vue-router';

export default Vue.extend({
  name: 'MenuItem',
  props: {
    icon: { type: String, required: false, default: null },
    badge: { type: String, required: false, default: null },
    labelBadge: { type: String, required: false, default: null },
    title: { type: String, required: false, default: '' },
    to: { type: String, required: false, default: null },
    href: { type: String, required: false, default: null },
    target: { type: String, required: false, default: null },
    link: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    tooltip: { type: Boolean, required: false, default: false },
    filledIcon: { type: String, required: false, default: null },
  },
  data() {
    return {
      value: this.$router.currentRoute.path === this.to,
    };
  },
  computed: {
    colorForIcon(): string {
      if (this.$vuetify.theme.dark && this.disabled) {
        return 'primary darken-3';
      }
      if (this.disabled) {
        return 'grey lighten-2';
      }
      return '';
    },
  },
  watch: {
    $route(to: Route, from: Route) {
      this.value = to.path === this.to;
    },
  },
  methods: {
    onClick() {
      this.$emit('click', true);
    },
  },
});

</script>
